import script from "./BranchOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./BranchOption.vue?vue&type=script&lang=ts&setup=true"

import "./BranchOption.vue?vue&type=style&index=0&id=afa05680&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afa05680"]])

export default __exports__